import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../common/AutoComplete";
import FormInput from "../common/FormInput";
import GenericFilterBox from "../common/GenericFilterBox";
import { nameof } from "../common/ObjectUtils";
import RfidCardImportService from "./service/RfidCardImportService";
import { RfidCardTypes } from "./tasks/Types";

interface Props {
    form: UseFormReturn<RfidCardTypes.IFormInput, any>;
}

const RfidCardImportFilterAndSearch = (props: Props) => {
    const [statusList, setStatusList] = useState<AutoCompleteOption[]>([]);

    const t = useOperationTranslation();

    const changeStatusName = (statusName: string) => {
        switch (statusName) {
            case "PROCESSED":
                return t("rfidCardImport.statusType.processed");
            case "PENDING":
                return t("rfidCardImport.statusType.pending");
            case "WITH_ERRORS_FORMAT":
                return t("rfidCardImport.statusType.errorFormat");
            case "WITH_ERRORS_DATA_INTEGRITY":
                return t("rfidCardImport.statusType.dataIntegrityError");
            case "WITH_ERRORS_GENERIC_ERROR":
                return t("rfidCardImport.statusType.genericError");
            default:
                return "";
        }
    };

    useEffect(() => {
        RfidCardImportService.get.rfidStatus().then(
            response => {
                console.log(response);
                setStatusList(response.map(status => ({
                    label: changeStatusName(status),
                    value: status
                })))
            }
        )
    }, []);

    const onReset = () => {
        props.form.reset({
            fileName: "",
            startDatetimeFrom: null,
            startDatetimeTo: null,
            status: ""
        })
    }

    return(
        <>
            <form id="idRfidForm" onSubmit={props.form.handleSubmit(() => {})}>
                <GenericFilterBox
                    formId="idRfidForm"
                    onReset={onReset}
                    showExtrasFilters={true}
                >
                    <FormInput
                        type="text"
                        fullWidth
                        label={t("rfidCardImport.fileName")}
                        variant="standard"
                        id="fileName"
                        name={nameof<RfidCardTypes.IFormInput>("fileName")}
                        formInstance={props.form}
                        inputProps={{
                            pattern: "[^%*$\"+&?^~Â`£=!@'/§#]{0,}",
                            onInput: (event) => {
                                if (event.currentTarget.validity.patternMismatch) {
                                event.currentTarget.setCustomValidity(
                                    t("rfidCardImport.regexMessage")
                                );
                                } else {
                                event.currentTarget.setCustomValidity("");
                                }
                            },
                        }}
                    />

                    <FormInput
                        type="date"
                        label={t("rfidCardImport.startDate")}
                        fullWidth
                        name={nameof<RfidCardTypes.IFormInput>("startDatetimeFrom")}
                        formInstance={props.form}
                        inputFormat={"DD/MM/YYYY HH:mm"}
                        ampm={false}
                        value={props.form.watch("startDatetimeFrom")}
                    />

                    <FormInput
                        type="date"
                        label={t("rfidCardImport.endDate")}
                        fullWidth
                        name={nameof<RfidCardTypes.IFormInput>("startDatetimeTo")}
                        formInstance={props.form}
                        inputFormat={"DD/MM/YYYY HH:mm"}
                        ampm={false}
                        value={props.form.watch("startDatetimeTo")}
                    />

                    <FormInput
                        type="select"
                        options={statusList}
                        name={nameof<RfidCardTypes.IFormInput>("status")}
                        formInstance={props.form}
                        fullWidth
                        label={t("rfidCardImport.status")}
                    />
                </GenericFilterBox>
            </form>
        </>
    )
}
export default RfidCardImportFilterAndSearch;
